import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Star, Eye, EyeOff, Trash2, Edit3 } from "lucide-react";
import AdminHeader from "../../components/layout/AdminHeader";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminOpportunities() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    const p = new URLSearchParams(); if (q) p.set("search", q);
    const { data } = await api.get(`/opportunities?${p.toString()}`);
    setList(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q]);

  const toggle = async (o, field) => {
    try { await api.patch(`/opportunities/${o.id}`, { [field]: !o[field] }); load(); }
    catch { toast.error("Failed"); }
  };
  const del = async (o) => {
    if (!window.confirm(`Delete "${o.title}"?`)) return;
    await api.delete(`/opportunities/${o.id}`); toast.success("Deleted"); load();
  };

  return (
    <div data-testid="page-admin-opportunities">
      <AdminHeader breadcrumb="Portfolio" title="Opportunities" subtitle="Manage the Altura Global opportunity library — public and private."
        actions={
          <>
            <input placeholder="Search title or ref…" value={q} onChange={(e) => setQ(e.target.value)} className="admin-input w-56" data-testid="opps-search" />
            <Link to="/altura-command/opportunities/new" className="btn-gold" data-testid="opp-new"><Plus className="h-3.5 w-3.5" /> New opportunity</Link>
          </>
        }
      />
      <div className="p-8">
        <div className="admin-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-[11px] uppercase tracking-[0.15em] text-altura-charcoal/50">
              <tr className="border-b border-altura-espresso/10">
                <th className="text-left py-3 px-2">Title</th><th className="text-left py-3 px-2">Ref</th>
                <th className="text-left py-3 px-2">Country</th><th className="text-left py-3 px-2">Type</th>
                <th className="text-left py-3 px-2">Status</th><th className="text-left py-3 px-2">Price</th>
                <th className="text-center py-3 px-2">Public</th><th className="text-center py-3 px-2">Featured</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {list.map((o) => (
                <tr key={o.id} className="border-b border-altura-espresso/5" data-testid={`opp-row-${o.id}`}>
                  <td className="py-3 px-2 font-medium text-altura-espresso">
                    <Link to={`/altura-command/opportunities/${o.id}`}>{o.title}</Link>
                    {(o.internal_notes || "").startsWith("[SAMPLE DATA") && (
                      <span className="ml-2 inline-block rounded-full border border-altura-burgundy/40 bg-altura-burgundy/10 px-2 py-0.5 text-[9px] uppercase tracking-widest text-altura-burgundy" data-testid={`opp-sample-${o.id}`}>Sample</span>
                    )}
                  </td>
                  <td className="py-3 px-2 font-mono text-xs text-altura-charcoal/60">{o.ref_no || "—"}</td>
                  <td className="py-3 px-2">{o.country}</td>
                  <td className="py-3 px-2 capitalize">{o.property_type}</td>
                  <td className="py-3 px-2"><span className="badge-soft capitalize">{(o.availability_status || "").replace("_", " ")}</span></td>
                  <td className="py-3 px-2 font-mono text-xs">{o.request_pricing_only ? "Request" : (o.price ? `$${o.price.toLocaleString()}` : "—")}</td>
                  <td className="py-3 px-2 text-center">
                    <button onClick={() => toggle(o, "is_public")} title="Toggle public" data-testid={`opp-toggle-public-${o.id}`}>
                      {o.is_public ? <Eye className="h-4 w-4 text-altura-gold-dark" /> : <EyeOff className="h-4 w-4 text-altura-charcoal/40" />}
                    </button>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <button onClick={() => toggle(o, "is_featured")} title="Toggle featured" data-testid={`opp-toggle-featured-${o.id}`}>
                      <Star className={`h-4 w-4 ${o.is_featured ? "text-altura-gold fill-altura-gold" : "text-altura-charcoal/40"}`} />
                    </button>
                  </td>
                  <td className="py-3 px-2">
                    <Link to={`/altura-command/opportunities/${o.id}`} className="text-altura-espresso/60 hover:text-altura-gold-dark mr-3" data-testid={`opp-edit-${o.id}`}><Edit3 className="h-4 w-4" /></Link>
                    <button onClick={() => del(o)} className="text-altura-espresso/60 hover:text-altura-burgundy" data-testid={`opp-delete-${o.id}`}><Trash2 className="h-4 w-4" /></button>
                  </td>
                </tr>
              ))}
              {list.length === 0 && <tr><td colSpan="9" className="py-10 text-center text-altura-charcoal/50">No opportunities yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
